import { render, staticRenderFns } from "./carhistory.vue?vue&type=template&id=50f11798&"
import script from "./carhistory.vue?vue&type=script&lang=js&"
export * from "./carhistory.vue?vue&type=script&lang=js&"
import style0 from "./carhistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../55/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports